const CloseIcon = () => {
    return (
        <img
            style={{ width: '100%', height: '100%' }}
            src="/images/close-icon.svg"
            alt="Document Icon"
        />
    );
};

export default CloseIcon;
